angular.module('app.controllers.non-paginated-forms', [
    'app.controllers.non-paginated-forms.email-us',
    'app.controllers.non-paginated-forms.esap',
    'app.controllers.non-paginated-forms.esap-spanish',
    'app.controllers.non-paginated-forms.historic',
    'app.controllers.non-paginated-forms.information-request',
    'app.controllers.non-paginated-forms.landlord-agreement',
    'app.controllers.non-paginated-forms.referral-feedback',
    'app.controllers.non-paginated-forms.supplier-attachment',
    'app.controllers.non-paginated-forms.supplier'
])
    /** Why is this directive here? Matt **/
    .directive("requiredfield", function () {
        return {
            restrict: 'A',
            compile: function (element, attr) {
                element.append(" <span class='required-marker'>*</span>");
            }
        };
    })
    .directive('updatedfile', function () {
        return {
            require: 'ngModel',
            link: function (scope, el, attrs, ngModel) {
                ngModel.$render = function () {
                    ngModel.$setViewValue(el.val());
                };

                el.bind('change', function () {
                    scope.$apply(function () {
                        ngModel.$render();
                        scope.filetoolarge = false;
                        scope.fileselected = false;

                        if (jQuery("#file").get(0).files[0] && (jQuery("#file").get(0).files[0].size > 20971520)) {
                            scope.filetoolarge = true;
                        }
                        else if (jQuery("#file").get(0).files[0] && (jQuery("#file").get(0).files[0].size !== 0)) {
                            scope.fileselected = true;
                        }
                    });
                });
            }
        };
    });
